import * as Actions from '../action';

const initialGlobal = {
  loading: false,
  socket: null,
  collapseItems: false
};

const initialCalculator = {
  data: null,
  activeStep: 0,
  idClient: 0,
  responses: {},
  loading: false,
  loadingApp: false,
  error: false,
  progress: 0
};

// ** Initial State
const initialState = {
  allQuotations: [],
  loading: [],
  data: [],
  assets: [],
  quote: {},
  filters: {},
  selectQuote: {},
  syncQuote: {},
  total: 1,
  params: {},
  selectedLease: null,
  newStatus: '',
  equipmentsQuote:[],
  newEquipmentsQuote:[],
  resultEquipmentsQuote:[],
  /* GLOBALS APP V2 */
  global: initialGlobal,
  /* GENERATE CALCULATOR PROPS */
  calculator: initialCalculator
  //initialsConcepts: []
};

const quotationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'FIND_NEST_QUOTATIONS':
      return { ...state, allQuotations: action.data };
    case 'FILTERS_NEST_QUOTATIONS':
      return { ...state, filters: action.data };
    case 'GET_NEST_QUOTATIONS':
      return { ...state, selectQuote: action.data };
    case 'GET_NEST_PRINT_QUOTATIONS':
      return { ...state, selectPrint: action.data };
    case 'SYNC_NEST_QUOTATIONS':
      return { ...state, selectQuote: action.data };
    case 'DELETE_NEST_QUOTATIONS':
      const updateDeletedAllQuotations = state.allQuotations.filter(quote => quote._id !== action.id);
      return { ...state, allQuotations: updateDeletedAllQuotations };
    case 'UPDATE_NEST_QUOTATIONS':
      const updatedAllQuotations = state.allQuotations.map(quote => {
        if (quote._id === action.data._id) {
          return { ...quote, ...action.data };
        }
        return quote;
      });
      return { ...state, allQuotations: updatedAllQuotations };
    case 'NEW_UPDATE_NEST_QUOTATIONS':
      const newAllQuotations = [action.data, ...state.allQuotations];
      return { ...state, allQuotations: newAllQuotations };
    case 'POST_NEST_QUOTATIONS':
      return { ...state, quote: action.data };
    case 'PATCH_NEST_QUOTATIONS':
      return { ...state, quote: action.data };
    case 'GET_DATA_ASSETS_QUOTATIONS':
      return { ...state, assets: action.data };
    case 'SYNC_NEST_QUOTE_LEASE':
      return { ...state, syncQuote: action.data };
    case 'PATCH_NEST_LEASE':
      return { ...state, newStatus: action.data };
    case 'PATCH_NEST_LEASE_BULK':
      return { ...state, newLeases: action.data };
    case 'PATCH_EQUIPMENTS_QUOTE':
      return { ...state, equipmentsQuote: action.data };
    case 'POST_EQUIPMENTS_QUOTE':
        return { ...state, equipmentsQuote: action.data };
    case 'GET_EQUIPMENTS_QUOTE':
        return { ...state, resultEquipmentsQuote: action.data };
    // case 'SET_LOADING_V2':
    //   return { ...state, loading: action.payload };
    // case 'GET_NEST_INITIALS_CONCEPTS':
    //       return { ...state, catInitialsConcepts: action.data }
    /* GENERATE CALCULATOR ACTIONS */
    case Actions.HANDLE_STEP:
      return {
        ...state,
        calculator: { ...state.calculator, activeStep: action.payload }
      };
    case Actions.SET_SYNC_LOADING:
      return {
        ...state,
        calculator: { ...state.calculator, loading: action.payload }
      };
    case Actions.SET_SELECTED_ID_CLIENT:
      return {
        ...state,
        calculator: { ...state.calculator, idClient: action.payload }
      };
    case Actions.SET_SYNC_ERROR:
      return {
        ...state,
        calculator: { ...state.calculator, error: action.payload }
      };
    case Actions.SET_CALCULATOR_PROGRESS:
      return {
        ...state,
        calculator: { ...state.calculator, progress: action.payload }
      };
    case Actions.SET_QUOTATION_DATA:
      return {
        ...state,
        calculator: { ...state.calculator, data: action.payload }
      };
    case Actions.SET_QUERY_RESPONSE:
      const { queryNumber, response } = action.payload;
      return {
        ...state,
        calculator: {
          ...state.calculator,
          responses: { ...state.calculator.responses, [queryNumber]: response }
        }
      };
    case Actions.CLEAR_CALCULATOR_STATE:
      return {
        ...state,
        calculator: initialCalculator
      };
    case Actions.SET_LOADING_V2:
      return { 
        ...state,
        global: { ...state.global, loading: action.payload }
      };
    case Actions.SET_COLLAPSE_MENU_V2:
      return { 
        ...state,
        global: { ...state.global, collapseItems: action.payload }
      };
    default:
      return { ...state };
  }
};
export default quotationsReducer;
